export const setPageTitle = (pageTitle) => (dispatch) => {
  if (pageTitle) dispatch({ type: 'SET_PAGE_TITLE', payload: pageTitle })
}
